import * as React from 'react';
import { Range } from 'rc-slider';

interface Props {
  bins: NdviRasterBins;
  onChange: (bins: NdviRasterBins) => void;
}

interface State {
}

export default class HistogramRanges extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  handleRangeChange = async (data: number[]) => {
    await this.setState({ isCustom: true });

    const { bins, onChange } = this.props;
    let newBins = [] as NdviRasterBins;
    for (const bin of bins) {
      newBins.push({ ...bin });
    }
    for (let i = 1; i < data.length; i++) {
      newBins[i].min = data[i];
      newBins[i - 1].max = data[i];
    }
    onChange(newBins);
  };

  getRangeProps() {
    const { bins } = this.props;
    let props = {
      value: [] as number[],
      count: 0,
      min: 0,
      max: 0
    };

    props.min = Math.min(...bins.map((b: NdviRasterBin) => b.min));
    props.max = Math.max(...bins.map((b: NdviRasterBin) => b.max));
    props.value = bins.map((b: NdviRasterBin) => b.min);

    return props;
  }

  getRangeStyles() {
    const { bins } = this.props;
    let props = {
      railStyle: {} as any,
      trackStyle: [] as any[],
      handleStyle: [] as any[]
    };
    if (bins.length) {
      props.railStyle = {
        backgroundColor: bins[bins.length - 1].color,
        height: 8
      };
      props.trackStyle = bins.map((b: NdviRasterBin) => ({
        backgroundColor: b.color,
        height: 8
      }));
      props.handleStyle = bins.map(
        (b: NdviRasterBin, index: number) =>
          index !== 0
            ? {
                borderColor: '#333',
                width: 20,
                height: 20,
                marginLeft: -10,
                marginTop: -6,
                boxShadow: 'none'
              }
            : {
                display: 'none'
              }
      );
    }
    return props;
  }

  render() {
    return (
      <Range
        {...this.getRangeProps()}
        {...this.getRangeStyles()}
        step={0.001}
        allowCross={false}
        onChange={this.handleRangeChange}
        style={{ marginTop: 24 }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HistogramRanges.tsx